module.exports = __webpack_public_path__ + "img/product-shot_03_loading.92e9127e.jpg";